import { MaskedFieldInputEvent } from '@cof/fs-masked-field-manager-base';
export const CurrencyFieldEventType = {
    'currency-field-input': 'currency-field-input'
};
export class CurrencyFieldInputEvent extends MaskedFieldInputEvent {
    /* c8 ignore next 14 - NOTE: C8 not properly covering constructor */
    constructor(validityState, maskedValue, unmaskedValue, originalTarget) {
        super(CurrencyFieldEventType['currency-field-input'], validityState, maskedValue, unmaskedValue, originalTarget);
    }
}
//# sourceMappingURL=CurrencyFieldEvent.js.map